import { Fetch } from './Utils.js';

export const Patch = (collection, _id, field, value, success, error) => {
  let body = {_id};
  body[field] = value;
  Fetch(`/api/data/${collection}`, 'PATCH', JSON.stringify(body), success, error);
}

export default Patch;
